import { PaginateResult } from "core/resources/types/shared";
import HeaderTable from "./components/HeaderTable";
import { ContaItemResponse } from "core/features/conta/typings";
import useContasRateioColumns from "core/features/rateio/hooks/useContasRateioColumns";
import NewTable from "../NewTable";

interface ContaTableProps {
  data: PaginateResult<ContaItemResponse> | undefined;
  searchValue: string;
  onSearch: (q?: string) => any;
  isLoading?: boolean;
  onSelectItems?: (items: any[]) => any;
  onPaginate?: (page: number) => any;
  excludeItems?: ContaItemResponse[];
  actions?: {
    title: string;
    onClick: ({ id }: { id: string }) => any;
  }[];
  enabledSearch?: boolean;
}

function ContaTable({
  data,
  searchValue,
  onSearch,
  isLoading,
  onPaginate,
  onSelectItems,
  excludeItems = [],
  actions,
  enabledSearch = true,
}: ContaTableProps) {
  const columns = useContasRateioColumns();

  const excludeItemsIds = excludeItems.map((i) => i.id);

  return (
    <NewTable
      hideShadow
      title={
        enabledSearch
          ? () => <HeaderTable value={searchValue} onSearch={onSearch} />
          : undefined
      }
      loading={isLoading}
      columns={columns}
      dataSource={
        data?.items.filter((i) => !excludeItemsIds.includes(i.id)) || []
      }
      actions={actions ? actions : []}
      customPagination={{
        currentPage: data?.meta?.currentPage ?? 1,
        totalItems: data?.meta?.totalItems ?? data?.items?.length,
        itemsPerPage: data?.meta?.itemsPerPage ?? data?.items?.length,
        onChangePage: (p) => onPaginate?.(p),
      }}
      rowSelection={
        onSelectItems
          ? {
              type: "checkbox",
              onChange: (
                _selectedRowKeys: React.Key[],
                selectedRows: ContaItemResponse[]
              ) => {
                onSelectItems(selectedRows);
              },
            }
          : undefined
      }
    />
  );
}

export default ContaTable;
